import { Box, Colors, FlexBox, H5, Tag, WorldIcon } from '@helloself/hello-self-ui';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { BaseTileProps } from '../../../model/types';
import { TagContent } from '../../TagContent';
import Tile from '../../Tile';
import languageOptions from './languages.json';

export type LanguagesTileProps = BaseTileProps & {
    languages?: string[];
};

const getName = (code: string) => {
    const language = languageOptions.find((option) => option.value === code);
    return language?.label || code;
};

export function LanguagesTile({ languages, isLoading }: LanguagesTileProps) {
    if (isLoading) {
        return (
            <Tile>
                <FlexBox flexDirection="column" gap="24px" data-testid="LanguagesTile">
                    <H5 margin="0">Languages I speak</H5>
                    <FlexBox flexDirection="row" gap="8px">
                        <Box height="24px" width="24px">
                            <WorldIcon width="24px" height="24px" />
                        </Box>
                        <FlexBox gap="8px" flexWrap="wrap">
                            <Skeleton width="64px" height="38px" borderRadius={8} style={{ padding: '3px 0' }} />
                            <Skeleton width="64px" height="38px" borderRadius={8} style={{ padding: '3px 0' }} />
                            <Skeleton width="64px" height="38px" borderRadius={8} style={{ padding: '3px 0' }} />
                        </FlexBox>
                    </FlexBox>
                </FlexBox>
            </Tile>
        );
    }

    if (!languages || languages.length === 0) {
        return null;
    }

    return (
        <Tile>
            <FlexBox flexDirection="column" gap="24px" data-testid="LanguagesTile">
                <H5 margin="0">Languages I speak</H5>
                <FlexBox flexDirection="row" gap="8px">
                    <Box height="24px" width="24px">
                        <WorldIcon width="24px" height="24px" />
                    </Box>
                    <FlexBox gap="8px" flexWrap="wrap">
                        {languages.map((code, index) => (
                            <Box padding="3px 0" key={index} borderRadius={8} border={`1px solid #e8e8e8`}>
                                <Tag color={Colors.black} backgroundColor={Colors.white}>
                                    <TagContent>{getName(code)}</TagContent>
                                </Tag>
                            </Box>
                        ))}
                    </FlexBox>
                </FlexBox>
            </FlexBox>
        </Tile>
    );
}
